/** "1 positive, 2 negative" — only the non-zero sentiment counts, in words. */
export function sentimentLabel(mention: {positive: number; neutral: number; negative: number}): string {
  const parts = [
    mention.positive ? `${mention.positive} positive` : '',
    mention.neutral ? `${mention.neutral} neutral` : '',
    mention.negative ? `${mention.negative} negative` : '',
  ].filter(Boolean);
  return parts.join(', ') || 'mentioned';
}
